export default "/assets/images/twilight-blue-sm.76abeefed967bc29.webp";